import React from 'react';
import styles from './ProgressTab.module.css';

function ProgressTab() {
  return (
    <div className={styles.ProgressTab}>
      <div className={styles.legend}>
        <span className={styles.status}>
          <span className={`${styles.colorBox} ${styles.started}`}></span>
          Started
        </span>
        <span className={styles.status}>
          <span className={`${styles.colorBox} ${styles.developing}`}></span>
          Developing
        </span>
        <span className={styles.status}>
          <span className={`${styles.colorBox} ${styles.expert}`}></span>
          Expert
        </span>
      </div>

      <div className={styles.devAreaBox}>
        <div className={styles.devHeader}>Development Area</div>
        <div className={styles.devEmptyBox}>No Photos And Videos Available</div>
      </div>
    </div>
  );
}

export default ProgressTab;
